import CrudService from "./crud-service";
import http from "./http-auth";

class DomainsService extends CrudService {
  async confirm(domainId) {
    return http.put(`/${this.apiName}/confirm/${domainId}`);
  }
}
export default new DomainsService("domains");
